module.exports = __webpack_public_path__ + "static/media/landings4fallback.96f0db28.svg";